<template>
    <form @submit.prevent="emitSubmit" class=" my-3 my-lg-0">
        <autocomplete @selected="emitSubmit" v-model="q" :route="route"></autocomplete>
        <!--
        <input type="search"  v-model="q" class="form-control header-search" placeholder="Recherche..." tabindex="1">
        <div class="input-icon-addon">
            <i class="fe fe-search"></i>
        </div>
        -->
    </form>
</template>
<script>
import { EventBus } from '../event-bus';
export default {
    data() {
        return {};
    },
    computed: {
        route() {
            return 'autocomplete/' + this.$store.getters['app/search_mode'];
        },
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                return this.$store.dispatch('app/setQ', value);
            }
        }
    },
    methods: {
        emitSubmit(selected) {
            var noRedirect = [
                '/catalog',
                '/categories',
                '/brands',
                '/vehicules',
                '/manufacturers',
                '/files',
            ];
            if (noRedirect.indexOf(window.location.pathname) == -1) {
                switch (selected.type) {
                    case 'category':
                        window.location = '/categories?q=' + this.q;
                        break;
                    case 'brand':
                        window.location = '/brands?q=' + this.q;
                        break;
                    case 'vehicule':
                        window.location = '/vehicules?q=' + this.q;
                        break;
                        break;
                    case 'file':
                        window.location = '/files?q=' + this.q;
                        break;
                    default:
                        window.location = '/catalog?q=' + this.q;
                        break;
                }
            } else {
                EventBus.$emit('search-input.submit');
            }
        }
    }
};
</script>
<style lang="scss">
</style>
